var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KvFileDropzone',_vm._g(_vm._b({attrs:{"variant":"outlined","size":"large"}},'KvFileDropzone',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }